/**
 * 车辆上架审核
 */
import React from 'react';
import { Row, Col, Icon, Tooltip, DatePicker, Input } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//车辆详情信息和审核
import VehicleAuditDetail from './VehicleAuditDetail';
//精选车辆推荐编辑
import VehicleRecommendEdit from './VehicleRecommendEdit';
//加载中遮罩
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth';
import DictSelect from '../../ui/DictSelect';
import messager from '../../ui/messager';
//商户选择
import MemberSelect from '../../crm/member/MemberSelect';
import moment from 'moment';


class VehicleAuditIndex extends React.Component {

    columns = [{
        title: '商户',
        dataIndex: 'memberName',
        width: '15%',
    }, {
        title: '车辆品牌型号',
        dataIndex: 'name',
        width: '20%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '18%',
    // }, {
    //     title: '提交时间',
    //     dataIndex: 'insertTime',
    //     width: '10%',
    }, {
        title: '审核时间',
        dataIndex: 'auditTime',
        width: '10%',
    }, {
        title: '金融合作车辆',
        dataIndex: 'financialCooperation',
        width: '5%',
        render: (text, record, index) => (
            text === 1 || text === "1" ? "是" : "否"
        )
    }, {
        title: '状态',
        dataIndex: 'statusStr',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="车辆详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                {global_data.authCode.includes("VEHICLE_AUDIT_TOPPING")&&record["status"]==="ONSELLING"?
                    <Tooltip title="车辆置顶">
                        <Icon type="shop" theme="filled" className="table-operate-icon" onClick={this.top.bind(this, record)} />
                    </Tooltip>:""}

                {global_data.authCode.includes("VEHICLE_AUDIT_COOPERATE")?
                    (record["financialCooperation"] === 1 || record["financialCooperation"] === "1") ?
                        <Tooltip title="取消此车辆的金融合作标志">
                            <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.markFinancialCooperation.bind(this, text, 0)} />
                        </Tooltip>
                        :
                        <Tooltip title="设置这个车辆为金融合作车辆">
                            <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.markFinancialCooperation.bind(this, text, 1)} />
                        </Tooltip>
                        :""
                }
                
            </div>
        )
    }];

    state = {
        visible: false,
        topVisiable: false,
        editData: {},
        editData2: {},
        loadData: '',
        queryData: {},
        loadingVisible: false
    };


    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    hiddenModal2 = () => {
        this.setState({ topVisiable: false, editData2: {} });
    };

    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/vehicleAudit/query/' + info.id,
            success: (res) => {
                res["memberName"] = info["memberName"];
                res["remarkVisibleStr"] = res["remarkVisible"] === 1 ? '是' : '否';
                res["carTypeStr"] = res["carType"] === 1 || res["carType"] === "1" ? '新车' : '二手车';
                this.transferData(res["vehicleImages"], "certificationImgs");
                this.transferData(res["thumbnails"], "certificationImgs");
                this.setState({ editData: res, visible: true, loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    transferData = (res, field) => {
        let data = res[field];
        for (let key in data) {
            res[field + "." + key] = data[key];
        }
        delete res[field];
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.auditStartDate = dateStrings[0];
        queryData.auditEndDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.status = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.keywords = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    memberSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.memberCode = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    markFinancialCooperation = (id, flag) => {
        http.post({
            url: "/vehicleAudit/markFinancialCooperation",
            data: { id: id, flag: flag },
            success: (res) => {
                this.state.loadData(this.state.queryData);
                if (flag === 1) {
                    messager.notify("设置这个车辆为金融合作车辆成功！");
                } else {
                    messager.notify("取消此车辆的金融合作标志成功！");
                }
            }
        });
    }

    top = (info, e) => {
        this.setState({ topVisiable: true, editData2: 
            { 
                "startTime": new moment(),
                "memberCode":info.memberCode,
                "vehicleId":info.id,
                "vehicleName":info.name
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车辆关键字或车架号"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }} />
                                <MemberSelect mall={1} allowClear={true} onChange={this.memberSelect} style={{ width: '250px', margin: '0 10px' }} />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <DictSelect category="MALL_VEHICLE_STATUS" allowClear={true} onChange={this.onSelect} style={{ width: '150px', margin: '0 10px' }} />
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/vehicleAudit/findVehiclePage"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <VehicleAuditDetail
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中..."
                />
                <VehicleRecommendEdit
                    visible={this.state.topVisiable}
                    onCancel={this.hiddenModal2.bind(this)}
                    editData={this.state.editData2}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }
}

export default VehicleAuditIndex;